import { ArrowRight, Leaf } from "lucide-react";

const LOGO_URL = "https://customer-assets-gfyr7b9c.emergentagent.net/job_battery-stock-hub/artifacts/1cicyv9h_GREENRGY%20NEW%20FINAL%20LOGO.webp";

export default function Login() {
  const handleGoogleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-login-gradient flex items-center justify-center p-6" data-testid="login-page">
      <div className="w-full max-w-[440px] bg-white rounded-3xl shadow-2xl p-10">
        <img src={LOGO_URL} alt="GREENRGY POWER" className="w-56 mx-auto mb-6" data-testid="brand-logo" />
        <h1 className="text-center text-2xl font-display uppercase text-zinc-900 mb-1">GREENRGY POWER</h1>
        <p className="text-center text-sm text-zinc-500 mb-8">Lithium Battery Stock &amp; Order Management Portal</p>

        <button
          onClick={handleGoogleLogin}
          data-testid="google-login-btn"
          className="w-full group inline-flex items-center justify-center gap-3 bg-[#28B516] hover:bg-[#15952A] text-white font-bold px-6 py-3.5 rounded-xl text-sm transition-colors"
        >
          <svg className="w-5 h-5" viewBox="0 0 24 24">
            <path fill="currentColor" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
            <path fill="currentColor" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
            <path fill="currentColor" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
            <path fill="currentColor" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
          </svg>
          Sign In with Google
          <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
        </button>

        <div className="mt-6 text-center text-xs text-zinc-400">
          New here? Sign in and the admin will approve your access.
        </div>

        <div className="mt-8 pt-6 border-t border-zinc-100 flex items-center justify-center gap-2 text-xs text-zinc-500">
          <Leaf className="w-3.5 h-3.5 text-[#28B516]" />
          Powered by clean energy tracking
        </div>
      </div>
    </div>
  );
}
